import Toastr from "../../../itrust_common/components/Toastr"

const PARENT = 'MARKETING_BLAST_'

const DEFAULT_STATE = { // analytics
  kpis: {},
  graphs: {},
  campaign_message_logs: [],
  loading: false,
}

let changes = null;
export default function campaignAnalyticsReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case `${PARENT}CAMPAIGN_ANALYTICS_LOAD_PENDING`:
    case `${PARENT}CAMPAIGN_SUB_LOG_ANALYTICS_LOAD_PENDING`:
    case `${PARENT}CAMPAIGN_MESSAGE_LOGS_LOAD_PENDING`:
    case `${PARENT}CAMPAIGN_SUB_LOG_MESSAGE_LOGS_LOAD_PENDING`:
      return { ...state, loading: true };

    case `${PARENT}CAMPAIGN_ANALYTICS_LOAD_REJECTED`:
    case `${PARENT}CAMPAIGN_SUB_LOG_ANALYTICS_LOAD_REJECTED`:
    case `${PARENT}CAMPAIGN_MESSAGE_LOGS_LOAD_REJECTED`:
    case `${PARENT}CAMPAIGN_SUB_LOG_MESSAGE_LOGS_LOAD_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        loading: false,
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_ANALYTICS_LOAD_FULFILLED`:
    case `${PARENT}CAMPAIGN_SUB_LOG_ANALYTICS_LOAD_FULFILLED`:
      changes = {
        ...response,
        loading: false,
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_MESSAGE_LOGS_LOAD_FULFILLED`:
    case `${PARENT}CAMPAIGN_SUB_LOG_MESSAGE_LOGS_LOAD_FULFILLED`:
      changes = {
        ...response,
        loading: false,
      }
      return { ...state, ...changes };

    default:
      return state;
  }
}